import React, { useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import MenuIcon from '../../assets/icons/menu.svg'
import DeleteIcon from '../../assets/icons/delete.svg'
import { FiEye, FiCheck } from 'react-icons/fi'

import Sidebar from '../../components/Sidebar/Sidebar'
import IndexPage from '../../components/IndexPage/IndexPage'
import ModalConfirm from '../../components/ModalConfirm/ModalConfirm'
import ModalSaleDetails from '../../components/ModalSaleDetails/ModalSaleDetails'
import { saleService } from '../../services/sale.service'
import { closeModal, showModal } from '../../utils/functions/modal'

import './SalesAdmin.css'
import '../../utils/animate.css'

const formatFecha = fecha => {
  if (!fecha) return ''
  const [fechaPart, horaPart] = fecha.split(' ')
  const [anio, mes, dia] = fechaPart.split('-')
  const hora = horaPart ? horaPart.slice(0, 5) : ''
  return `${dia}/${mes}/${anio} ${hora}`
}

const FILTERS = [
  { value: 'todas', label: 'Todas' },
  { value: 'pendiente', label: 'Pendientes' },
  { value: 'pagado', label: 'Pagadas' }
]

const SalesAdmin = () => {
  const [sales, setSales] = useState(undefined)
  const [stats, setStats] = useState()
  const [filtro, setFiltro] = useState('todas')
  const [pageActual, setPageActual] = useState(1)
  const [indexPages, setIndexPages] = useState([])
  const [cantPages, setCantPages] = useState(0)

  const [saleDetails, setSaleDetails] = useState()
  const [idSale, setIdSale] = useState()
  const [message, setMessage] = useState(undefined)

  const getAllSales = async () => {
    const response = await saleService.getAllSales(filtro, pageActual)
    if (response.status === 200) {
      setSales(response.data.ventas)
      setStats(response.data.estadisticas)
      setCantPages(response.data.cantPaginas)
      const indexCopy = []
      for (let i = 1; i <= response.data.cantPaginas; i++) {
        indexCopy.push(i)
      }
      setIndexPages(indexCopy)
    }
  }

  useEffect(() => {
    getAllSales()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageActual, filtro])

  const showSidebar = () => {
    document.querySelector('.container-sidebar')?.classList.add('show-sidebar')
  }

  const changeFiltro = value => {
    setFiltro(value)
    setPageActual(1)
  }

  const showModalDetails = sale => {
    setSaleDetails(sale)
    showModal('.container-modal-sale-details')
  }

  const showModalConfirmPayment = sale => {
    showModal('.container-modal-confirm')
    setIdSale(sale.id)
    setMessage({
      description: `¿Confirmar el pago de la venta #${sale.id}?`,
      status: 300,
      action: confirmPayment
    })
  }

  const confirmPayment = async id => {
    setMessage({ description: 'Confirmando pago...', status: 1000 })
    const response = await saleService.confirmPayment(id)
    setTimeout(async () => {
      setMessage({
        description: response.data.message,
        status: response.data.status
      })
      if (response.data.status === 200) {
        await getAllSales()
      }
      setTimeout(() => {
        closeModal('.container-modal-confirm')
      }, 2000)
    }, 1000)
  }

  const showModalDelete = sale => {
    showModal('.container-modal-confirm')
    setIdSale(sale.id)
    setMessage({
      description: `¿Eliminar la venta #${sale.id}? Se repondrá el stock de los productos.`,
      status: 300,
      action: deleteSale
    })
  }

  const deleteSale = async id => {
    setMessage({ description: 'Eliminando venta...', status: 1000 })
    const response = await saleService.deletePayment(id)
    setTimeout(async () => {
      setMessage({
        description: response.data.message,
        status: response.data.status
      })
      if (response.data.status === 200) {
        await getAllSales()
      }
      setTimeout(() => {
        closeModal('.container-modal-confirm')
      }, 2000)
    }, 1000)
  }

  return (
    <>
      <ModalConfirm message={message} actionConfirm={message?.action} idSale={idSale} />
      <ModalSaleDetails sale={saleDetails} setSale={setSaleDetails} />

      <div className="container-sales-admin">
        <Sidebar />
        <div className="sales-admin">
          <div className="head-admin">
            <button className="btn-menu" onClick={() => showSidebar()}>
              <img src={MenuIcon} alt="" />
            </button>
            <h1 className="animate fadeIn">VENTAS</h1>
          </div>

          <div className="sales-stats animate fadeIn">
            <div className="stat-card">
              <span className="stat-label">Ingresos totales</span>
              <NumberFormat
                className="stat-value"
                value={stats?.ingresosTotales || 0}
                displayType="text"
                prefix="$"
                thousandSeparator="."
                decimalSeparator=","
              />
            </div>
            <div className="stat-card">
              <span className="stat-label">Ventas pagadas</span>
              <span className="stat-value">{stats?.cantPagadas ?? 0}</span>
            </div>
            <div className="stat-card">
              <span className="stat-label">Ventas pendientes</span>
              <span className="stat-value">{stats?.cantPendientes ?? 0}</span>
            </div>
          </div>

          <div className="sales-filters animate fadeIn">
            {FILTERS.map(f => (
              <button
                key={f.value}
                className={`filter-btn ${filtro === f.value ? 'active' : ''}`}
                onClick={() => changeFiltro(f.value)}
              >
                {f.label}
              </button>
            ))}
          </div>

          <div className="table-sales">
            {sales && sales.length > 0 && (
              <>
                <table cellSpacing="0">
                  <thead className="head-table animate fadeIn">
                    <tr>
                      <th>N°</th>
                      <th>Fecha</th>
                      <th>Cliente</th>
                      <th>Productos</th>
                      <th>Total</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sales.map((sale, key) => (
                      <tr key={sale.id} style={{ animationDelay: `${Math.min(key, 8) * 0.06}s` }}>
                        <td>{sale.id}</td>
                        <td>{formatFecha(sale.fechaCompra)}</td>
                        <td>{sale.comprador.nombre}</td>
                        <td>{sale.compra.length} producto{sale.compra.length !== 1 ? 's' : ''}</td>
                        <td>
                          <NumberFormat
                            value={sale.total}
                            displayType="text"
                            prefix="$"
                            thousandSeparator="."
                            decimalSeparator=","
                          />
                        </td>
                        <td>
                          <span className={`sale-status-badge ${sale.estado}`}>
                            {sale.estado === 'pagado' ? 'Pagado' : 'Pendiente'}
                          </span>
                        </td>
                        <td>
                          <button className="action" onClick={() => showModalDetails(sale)} title="Ver detalle">
                            <FiEye />
                          </button>
                          {sale.estado === 'pendiente' && (
                            <button
                              className="action confirm-action"
                              onClick={() => showModalConfirmPayment(sale)}
                              title="Confirmar pago"
                            >
                              <FiCheck />
                            </button>
                          )}
                          <button className="action" onClick={() => showModalDelete(sale)} title="Eliminar venta">
                            <img src={DeleteIcon} alt="" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <IndexPage
                  pageActual={pageActual}
                  setPageActual={setPageActual}
                  indexPages={indexPages}
                  cantPages={cantPages}
                />
              </>
            )}
            {sales && sales.length === 0 && (
              <div className="empty-sales">
                <p>No hay ventas para este filtro</p>
              </div>
            )}
            {sales === undefined && <div className="empty-sales"></div>}
          </div>
        </div>
      </div>
    </>
  )
}

export default SalesAdmin
